import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import object from '@mailobj-browser/front/js/utils/object.js'

const handlers = new WeakMap()
const items = new WeakMap()
const wrappers = new WeakSet()

const onClick = object(listener, {
  type: click,
  passive,
  task: async button => {
    const parentWrapper = closest('[data-contract~="fieldsCollection.add.wrapper"]', button)
    const set = one('[type="hidden"][name*="_set"]', parentWrapper)
    const nb = one('[type="hidden"][name*="_nb"]', parentWrapper)

    await handlers.get(button)?.(items.get(button), set, nb)
  }
})

export const handle = (button, handler) => {
  const item = closest('[data-contract~="fieldsCollection.item.wrapper"]', button)

  if (!wrappers.has(item)) {
    return
  }

  handlers.set(button, handler)
  items.set(button, item)
  onClick.listen(button)

  queueMicrotask(async () => {
    await removed(button)
    handlers.delete(button)
    items.delete(button)
  })
}

export default wrapper => {
  wrappers.add(wrapper)

  queueMicrotask(async () => {
    await removed(wrapper)
    wrappers.delete(wrapper)
  })
}
